<button (click)="addNewDayToACalendar()" class="btn btn-primary-outline add-button">Add</button>
<h4>Preferred times off</h4>

<div class="text-center mb-3">
  <button class="btn btn-outline-secondary"
          [ngClass]="{'active-button': isListActive()}"
          (click)="isListActive.set(true)"><i class="fa fa-th-list"></i> List
  </button>
  <button class="btn btn-outline-secondary ms-1"
          [ngClass]="{'active-button': !isListActive()}"
          (click)="isListActive.set(false)">
    <li class="fa fa-calendar-alt"></li>
    Calendar
  </button>
</div>
<app-week-select
        [selectedMonday]="selectedMonday()"
        [latestMonday]="latestMonday()"
        (selectedMondayEvent)="selectWeek($event)">
</app-week-select>

@if (isListActive()) {
  <div>
    <app-sortable-table [headers]="headers" (sort)="onSort($event)">
      @for (preferredTimeOff of weekPreferredTimesOffList() | listSort: tableSortEvent(); track preferredTimeOff) {
        <tr>
          <td>{{ preferredTimeOff.date }}</td>
          <td>{{ preferredTimeOff.time }}</td>
          <td>{{ preferredTimeOff.reason }}</td>
          @if (canEdit()) {
            <td>
              <i (click)="editCalendarDay(preferredTimeOff.originalObject, EditType.DELETE)"
                 class="fa fa-xs fa-trash pointer float-end me-4"></i>
              <i (click)="editCalendarDay(preferredTimeOff.originalObject, EditType.EDIT)"
                 class="fa fa-xs fa-pen pointer float-end me-2"></i>
            </td>
          }
          @if (!canEdit()) {
            <td></td>
          }
        </tr>
      }
    </app-sortable-table>
  </div>
}
@if (!isListActive() && hours().length > 0) {
  <div>
    <table class="table employee-calendar-table">
      <thead>
      <tr>
        <th></th>
        @for (weekday of weekdays; track weekday) {
          <th>
            {{ weekday | dayOfWeekParse }}
            <ng-container
                    *ngTemplateOutlet="template; context: {$implicit: getPreferredTimeOff(weekday)}"></ng-container>
          </th>
        }
      </tr>
      </thead>
      <tbody>
        @for (hour of hours(); track hour) {
          <tr>
            <td>
              <span class="hour">{{ hour | timeParse | dateFormat: 'HH:mm' }}</span>
            </td>
            @for (weekday of weekdays; track weekday) {
              <td></td>
            }
          </tr>
        }
      </tbody>
    </table>
    <ng-template #template let-preferredTimeOff>
      @if (preferredTimeOff && preferredTimeOff.startTime) {
        <div class="preferred-day-off"
             [ngClass]="{'temporary-preferred-day-off': preferredTimeOff.date, 'ongoing-preferred-day-off': preferredTimeOff.startDate}"
             appTimeSlot
             [gridStart]="hours()[0]"
             [startTime]="getStartTimeForCalendar(preferredTimeOff)"
             [endTime]="getEndTimeForCalendar(preferredTimeOff)"
             [cellHeight]="cellHeight">
          <div class="title">
            @if (preferredTimeOff.startDate) {
              <strong>ONGOING<br></strong>
            }
            @if (preferredTimeOff.date) {
              <strong>TEMPORARY<br></strong>
            }
            @if (preferredTimeOff.date) {
              <strong>{{ preferredTimeOff.date | dateParse | dateFormat: 'DD MMMM YYYY' }}<br></strong>
            }
            <br>{{ preferredTimeOff.reason }}
          </div>
          @if (canEdit()) {
            <div>
              <i (click)="editCalendarDay(preferredTimeOff, EditType.EDIT)" class="fa fa-1x fa-cog pointer"></i>
              <i (click)="editCalendarDay(preferredTimeOff, EditType.DELETE)" class="fa fa-1x fa-trash pointer"></i>
            </div>
          }
        </div>
      }
    </ng-template>
  </div>
}